import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import MovieView from '../views/MovieView.vue'
import CinemaView from '../views/CinemaView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: [
      { 
        title: 'Kinoprogramm LuS' 
      },
      {
        property: 'og:title',
        content: 'Kinoprogramm LuS',
      },
      {
        property: 'og:type', 
        content: 'website' 
      },
      {
        property: 'og:description',
        content: 'Alle Kino-Neustarts nit Programm.',
      }
    ]
  },
  {
    path: '/movie/:id/:pageTitle',
    name: 'movie',
    component: MovieView,
    props: true,
    meta: {
      title: 'Film - Kinoprogramm LuS'
    }
  },
  {
    path: '/cinema/:id/:pageTitle',
    name: 'cinema',
    component: CinemaView,
    props: true,
    meta: {
      title: 'Kino - Kinoprogramm LuS'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0, behavior: 'smooth', }
  },
})


router.beforeEach((to, from, next) => {
  const titleFromParams = to.params?.pageTitle
  if (titleFromParams) {
    document.title = `${titleFromParams} - Kinoprogramm LuS`
  } else {
    document.title = to.meta?.title ?? 'Kinoprogramm LuS'
  }
  next()
})


export default router
